import Controller from '@ember/controller';

export default class AppFileController extends Controller {
  queryParams = ['action', 'ext', 'name', 'webViewLink', 'isGoogleDoc', 'downloadUrl'];
  action = 'edit';
  ext = null;
  name = null;
  webViewLink = null;
  isGoogleDoc = false;
  downloadUrl = null;
}
